import {
  INIT_CATEGORY,
  INIT_GALLERY,
  CLICK_CATEGORY,
  CLICK_PAGER,
  CLICK_MODAL_OPEN,
  CLICK_MODAL_CLOSE,
} from "@/shared/components/photo_gallery/constants/action_types";

// カテゴリをクリック
export const clickCategory = (categoryId) => {
  return {
    type: CLICK_CATEGORY,
    payload: {
      categoryId,
    },
  };
};

// ページャーをクリック
export const clickPager = (page) => {
  return {
    type: CLICK_PAGER,
    payload: {
      page,
    },
  };
};

// フォトをクリック
export const clickPhoto = (index) => {
  return {
    type: CLICK_MODAL_OPEN,
    payload: {
      index,
    },
  };
};

// 一覧へをクリック
export const clickClose = () => {
  return {
    type: CLICK_MODAL_CLOSE,
  };
};

// カテゴリを初期化
export const initCategory = (categories, categoryId) => {
  return {
    type: INIT_CATEGORY,
    payload: {
      categories,
      categoryId,
    },
  };
};

// ギャラリー初期化
export const initGallery = (photos, accentColor) => {
  return {
    type: INIT_GALLERY,
    payload: {
      photos,
      accentColor,
    },
  };
};

// 初期処理
export const initialize = (
  store,
  photos,
  categories,
  categoryId,
  accentColor,
) => {
  return () => {
    store.dispatch(initCategory(categories, categoryId));
    store.dispatch(initGallery(photos, accentColor));
  };
};
